module.exports = __webpack_public_path__ + "hazime.jpg?ffcd782c9870818d37e7f66ce1b3c993";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/hazime.jpg
// module id = 121
// module chunks = 0